import { Component, computed, input, signal } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-field',
  templateUrl: './field.html',
  styleUrl: './field.scss',
})
export class FieldComponent {
  styleClass = input<string>('');
  label = input<string>('');
  for = input<string>('');
  isRequired = input<boolean>(false);
  showIsOptional = input<boolean>(false);
  tooltip = input<string>('');

  /** Id of the control rendered inside this field; registered by the control itself. */
  private readonly _controlId = signal('');
  readonly labelFor = computed(() => this._controlId() || this.for());

  registerControlId(id: string): void {
    this._controlId.set(id);
  }
}
